import React from 'react';
import { Box, Typography } from '@mui/material';
import { ImageWithFallback } from '../figma/ImageWithFallback';

export function HeroSection() {
  return (
    <Box
  sx={{
    position: 'relative',
    height: 400,
    background: 'linear-gradient(to right, #2563eb, #7c3aed)',
    overflow: 'hidden',
    mt: { xs: 10, md: 10 },   
  }}
>

      <Box 
        sx={{ 
          position: 'absolute', 
          inset: 0, 
          bgcolor: 'rgba(0,0,0,0.2)'
        }} 
      />
      <ImageWithFallback
        src="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&h=400&fit=crop"
        alt="Hero background"
        className="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-50"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          mixBlendMode: 'overlay',
          opacity: 0.5,
        }}
      />
      <Box 
        sx={{ 
          position: 'relative', 
          maxWidth: 1400, 
          mx: 'auto', 
          px: { xs: 2, sm: 3, lg: 4 }, 
          height: '100%', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center',
          color: 'white',
        }}
      >
        <Typography variant="h2" component="h1" sx={{ mb: 2, maxWidth: 600, fontWeight: 'bold' }}>
          Discover Your Perfect Stay
        </Typography>
        <Typography variant="h5" sx={{ maxWidth: 500, opacity: 0.9 }}>
          From luxury hotels to cozy homestays, find unique accommodations for your next adventure
        </Typography>
      </Box>
    </Box>
  );
}
